(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('MedalBoardDialogController', MedalBoardDialogController);

    MedalBoardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MedalBoard', 'Race', 'Runner', 'Medal'];

    function MedalBoardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MedalBoard, Race, Runner, Medal) {
        var vm = this;

        vm.medalBoard = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.races = Race.query();
        vm.runners = Runner.query();
        vm.medals = Medal.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medalBoard.id !== null) {
                MedalBoard.update(vm.medalBoard, onSaveSuccess, onSaveError);
            } else {
                MedalBoard.save(vm.medalBoard, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:medalBoardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
